import React, { Component } from "react";
import { Container, Row, Col, Button, Label } from "reactstrap";
import { inject, observer } from "mobx-react";
import { Link } from "react-router-dom";
import { IconeSoma } from '../../../comum/components/Icones';
import DataWrapper from '../../../principal/containers/DataWrapper';
import FiltrosAgendamento from "../components/FiltrosAgendamento";
import { TabelaAgendamento } from "../components/TabelaAgendamento";
import AgendamentoStore from "../stores/AgendamentoStore";
import ModalForm from '../../../comum/components/ModalForm';
import ModalAviso from "../../../comum/components/ModalAviso";
import LoadingImage from "../../../comum/components/LoadingImage";

@inject("store")
@DataWrapper
@observer
export class Agendamento extends Component {
    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
        this.loginStore = this.props.store.loginStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;

        this.controller = new AgendamentoStore();
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Agendamento de Container");

        this.controller.carregarTipoAgendamento();
        this.controller.carregarStatus();
        this.controller.carregarTamanhos();
        process.env.ssa && this.controller.carregarTransportadoras();

        this.appStore.showTopbar(true);

        let voltarParam = _.get(this.props.location.state, `voltar`);
        this.props.store.appStore.showVoltarTopBar(voltarParam ? true : false, voltarParam ? voltarParam : '/');
    }

    can = (operacao = "C", tarefa = "AgendamentoContainer") => this.loginStore.can(tarefa, operacao)

    modalAlerta() {
        return this.controller.modalAlerta && Date.now() < new Date('2020-05-02') &&
            <ModalForm className="tamanho-modal-acomproc"
                esconderSalvar={true}
                onClickCancelar={() => this.controller.modalAlerta = false}
                labelCancelar="FECHAR"
            >
                <p className="text-desistencia">
                    <h1 className="text-center"><strong>COMUNICADO</strong></h1>
                    Prezado Cliente,<br /><br />
                    Em virtude do Feriado do Dia do Trabalhador, no dia 01/05, o Terminal terá horários reduzidos, conforme abaixo.<br />
                    <br />
                    <strong>Recebimento de Container</strong><br />
                            Cheios: 00hs – 6hs<br />
                            Vazios: 00hs – 6hs<br />
                    <strong>Retirada de Container</strong><br />
                            Cheios: Sem expediente<br />
                            Vazios: 00hs – 6hs<br />
                    <strong>Armazéns</strong><br />
                            Sem Operação<br />
                    <br />
                    Caso exista necessidade de entrega, gentileza encaminhar sua solicitação para análise de viabilidade aos nossos canais de atendimento:<br />
                    <br />
                    <strong>Atendimento ao Cliente:</strong><br /> 53 3234.3030 - atendimento.tcrg@wilsonsons.com.br<br />
                    <strong>Import Desk:</strong><br /> 53 3234.3134 - importdesk.tcrg@wilsonsons.com.br<br />
                    <strong>Reefer Intelligence:</strong><br /> 53 3234.3144 - reeferintelligence.tcrg@wilsonsons.com.br<br />
                    <strong>Atendimento Armador:</strong><br /> 53 3234.3145 - atendimentoarmador.tcrg@wilsonsons.com.br<br /><br />
                    Cordialmente,<br />
                    TECON Rio Grande S/A
                </p>
            </ModalForm>
    };

    modalMensagemFiltro() {
        return this.controller.msgFiltro !== "" &&
        <ModalAviso
            onClickFechar = {this.controller.fecharModalFiltro}
        >
            <h2>{this.controller.msgFiltro}</h2>
        </ModalAviso>
    }

    render() {
        return (
            <div className="form-wrapper">
                {this.modalAlerta()}
                {this.modalMensagemFiltro()}
                <Container className="agendamento tela-botoes-inclusao-topo" fluid>
                    <Row className="botoes-inclusao-topo">
                        <Col xs={12} sm={12} md={12} >
                            {this.can("I") &&
                                <Link to="agendamento-container/cadastro">
                                    <Button className="mb-1 btn-com-bordas-primary">Novo Agendamento</Button>
                                </Link>
                            }
                        </Col>
                    </Row>
                    <FiltrosAgendamento controller={this.controller} />
                    <TabelaAgendamento controller={this.controller} />
                </Container>
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-visualizar/tela/Agendamento.js